<script>
	/** @type {String} */
	export let autocomplete = '';
	/** @type {boolean} */
	export let disabled = false;
	/** @type {String} */
	export let id = '';
	/** @type {String} */
	export let label = '';
	/** @type {string | undefined} */
	export let name = undefined;
	/**
	 * @type {Array<{
	 *  label: string;
	 *  value: string;
	 *  selected?: boolean;
	 *  disabled?: boolean;
	 *  hidden?: boolean;
	 * }> | undefined}
	 */
	export let options = undefined;
	/** @type {null | string} */
	export let placeholder = null;
	/** @type {boolean} */
	export let required = false;
	/** @type {'sm' | 'md' | 'lg'} */
	export let size = 'md';
	/** @type {string | null | undefined} */
	export let value = undefined;
	/** @type {boolean} */
	export let spellcheck = false;

	let tag = $$slots.label || label ? 'label' : 'div';
	$: tag;

	id = id ? `id-${crypto.randomUUID()}` : crypto.randomUUID();
	$: id;
</script>

<svelte:element
	this={tag}
	class="select {size}"
	class:active={value && value !== placeholder}
	class:disabled
>
	{#if $$slots.label || label}
		<div class="label">
			<slot name="label">
				{label}
			</slot>
		</div>
	{/if}
	<select
		class="field"
		class:active={value && value !== placeholder}
		{autocomplete}
		{disabled}
		{id}
		{name}
		{required}
		{spellcheck}
		bind:value
		on:change
	>
		{#if placeholder}
			<option class="placeholder" selected hidden>{placeholder}</option>
		{/if}
		<slot>
			{#if options?.length}
				{#each options as option}
					<option value={option.value} disabled={option.disabled} hidden={option.hidden}
						>{option.label}</option
					>
				{/each}
			{/if}
		</slot>
	</select>
</svelte:element>

<style>.select{--hsl-select-border:var(--hsl-gray-light);display:inline-grid;gap:.375rem}.select:not(.disabled):hover{--hsl-select-border:var(--hsl-primary), 0.5}.select:not(.disabled):focus-within{--hsl-select-border:var(--hsl-primary)}.select.active:not(.disabled){--hsl-select-border:var(--hsl-primary)}.select.disabled,.select.disabled select{cursor:not-allowed}.label,select{font:var(--f-ui-md-medium)}.label{color:hsla(var(--hsl-gray-extra-dark))}.field{display:inline-flex;background:hsla(var(--hsl-white));border:2px solid hsla(var(--hsl-select-border))}.sm .field{border-radius:.875rem;padding:.625rem}.md .field{padding:.75rem .625rem}.lg .field{padding:.875rem .75rem}.lg .field,.md .field{border-radius:1rem}select{background:0 0;outline:0;width:100%}:not(.active) select{color:hsla(var(--hsl-black),.5)!important}</style>
